import { useMutation } from 'react-query';

import { EindomfinansAPI } from '../api';

export function useForwardDocumentsMutation() {
    return useMutation(EindomfinansAPI.forwardDocuments);
}
